import { IBoardData } from '../Game/BoardUtils';

interface IAllLevelsConfig {
    [key: string]: IMapConfig;
}

interface IMapConfig {
    [key: number]: string;
}

export interface ILevelConfig {
    goal: IGoalData; // use goal type
    winTime: number;
    pairsPerValue: number;
    values: string[];
    levelId: string;
    levelScoreTiers: number[];
    fillType: string;
    layerDiffs: number;
    seeds?: string[];
}

export interface IGoalData {
    type: string;
    target: number | string;
}

export const NODES_PER_MAP = 50;

export const MapList = ['machu', 'rome', 'seoul', 'scotland', 'morocco', 'newyork'];

export const LastLevel = MapList.length * NODES_PER_MAP;

export const LevelConfig: IAllLevelsConfig = {
    machu: {
        1: '001',
        2: '002',
        3: '003',
        4: '004',
        5: '005',
        6: '006',
        7: '007',
        8: '008',
        9: '009',
        10: '010',
        11: '011',
        12: '012',
        13: '013',
        14: '014',
        15: '015',
        16: '016',
        17: '017',
        18: '018',
        19: '019',
        20: '020',
        21: '021',
        22: '022',
        23: '023',
        24: '024',
        25: '025',
        26: '026',
        27: '027',
        28: '028',
        29: '029',
        30: '030',
        31: '031',
        32: '032',
        33: '033',
        34: '034',
        35: '035',
        36: '036',
        37: '037',
        38: '038',
        39: '039',
        40: '040',
        41: '041',
        42: '042',
        43: '043',
        44: '044',
        45: '045',
        46: '046',
        47: '047',
        48: '048',
        49: '049',
        50: '050',
    },
    rome: {
        1: '051',
        2: '052',
        3: '053',
        4: '054',
        5: '055',
        6: '056',
        7: '057',
        8: '058',
        9: '059',
        10: '060',
        11: '061',
        12: '062',
        13: '063',
        14: '064',
        15: '065',
        16: '066',
        17: '067',
        18: '068',
        19: '069',
        20: '070',
        21: '071',
        22: '072',
        23: '073',
        24: '074',
        25: '075',
        26: '076',
        27: '077',
        28: '078',
        29: '079',
        30: '080',
        31: '081',
        32: '082',
        33: '083',
        34: '084',
        35: '085',
        36: '086',
        37: '087',
        38: '088',
        39: '089',
        40: '090',
        41: '091',
        42: '092',
        43: '093',
        44: '094',
        45: '095',
        46: '096',
        47: '097',
        48: '098',
        49: '099',
        50: '100',
    },
    seoul: {
        1: '101',
        2: '102',
        3: '103',
        4: '104',
        5: '105',
        6: '106',
        7: '107',
        8: '108',
        9: '109',
        10: '110',
        11: '111',
        12: '112',
        13: '113',
        14: '114',
        15: '115',
        16: '116',
        17: '117',
        18: '118',
        19: '119',
        20: '120',
        21: '121',
        22: '122',
        23: '123',
        24: '124',
        25: '125',
        26: '126',
        27: '127',
        28: '128',
        29: '129',
        30: '130',
        31: '131',
        32: '132',
        33: '133',
        34: '134',
        35: '135',
        36: '136',
        37: '137',
        38: '138',
        39: '139',
        40: '140',
        41: '141',
        42: '142',
        43: '143',
        44: '144',
        45: '145',
        46: '146',
        47: '147',
        48: '148',
        49: '149',
        50: '150',
    },
    scotland: {
        1: '151',
        2: '152',
        3: '153',
        4: '154',
        5: '155',
        6: '156',
        7: '157',
        8: '158',
        9: '159',
        10: '160',
        11: '161',
        12: '162',
        13: '163',
        14: '164',
        15: '165',
        16: '166',
        17: '167',
        18: '168',
        19: '169',
        20: '170',
        21: '171',
        22: '172',
        23: '173',
        24: '174',
        25: '175',
        26: '176',
        27: '177',
        28: '178',
        29: '179',
        30: '180',
        31: '181',
        32: '182',
        33: '183',
        34: '184',
        35: '185',
        36: '186',
        37: '187',
        38: '188',
        39: '189',
        40: '190',
        41: '191',
        42: '192',
        43: '193',
        44: '194',
        45: '195',
        46: '196',
        47: '197',
        48: '198',
        49: '199',
        50: '200',
    },
    morocco: {
        1: '201',
        2: '202',
        3: '203',
        4: '204',
        5: '205',
        6: '206',
        7: '207',
        8: '208',
        9: '209',
        10: '210',
        11: '211',
        12: '212',
        13: '213',
        14: '214',
        15: '215',
        16: '216',
        17: '217',
        18: '218',
        19: '219',
        20: '220',
        21: '221',
        22: '222',
        23: '223',
        24: '224',
        25: '225',
        26: '226',
        27: '227',
        28: '228',
        29: '229',
        30: '230',
        31: '231',
        32: '232',
        33: '233',
        34: '234',
        35: '235',
        36: '236',
        37: '237',
        38: '238',
        39: '239',
        40: '240',
        41: '241',
        42: '242',
        43: '243',
        44: '244',
        45: '245',
        46: '246',
        47: '247',
        48: '248',
        49: '249',
        50: '250',
    },
    newyork: {
        1: '251',
        2: '252',
        3: '253',
        4: '254',
        5: '255',
        6: '256',
        7: '257',
        8: '258',
        9: '259',
        10: '260',
        11: '261',
        12: '262',
        13: '263',
        14: '264',
        15: '265',
        16: '266',
        17: '267',
        18: '268',
        19: '269',
        20: '270',
        21: '271',
        22: '272',
        23: '273',
        24: '274',
        25: '275',
        26: '276',
        27: '277',
        28: '278',
        29: '279',
        30: '280',
        31: '281',
        32: '282',
        33: '283',
        34: '284',
        35: '285',
        36: '286',
        37: '287',
        38: '288',
        39: '289',
        40: '290',
        41: '291',
        42: '292',
        43: '293',
        44: '294',
        45: '295',
        46: '296',
        47: '297',
        48: '298',
        49: '299',
        50: '300',
    },
};

export interface IGameSizeInfo {
    gameWidth: number;
    gameHeight: number;
    gameScale: number;
    xOffset: number;
    yOffset: number;
}

const defaultSize: IGameSizeInfo = {
    gameHeight: 1024,
    gameScale: 1,
    gameWidth: 576,
    xOffset: 0,
    yOffset: 0,
};

// naahhh
let gameSize: IGameSizeInfo = defaultSize;
export const getGameSize = () => {
    return gameSize;
};

export const setGameSize = (size: IGameSizeInfo) => {
    gameSize = size;
};

let boardData: IBoardData = null;
export const setBoardData = (data: IBoardData) => {
    boardData = data;
};
export const getLoadedBoard = () => {
    return boardData;
};
